module.exports = __webpack_public_path__ + "static/media/cloudComputing-min.23c2451d.jpg";